export const dataUploadTableConfig = {
    list: {
         tableMapper: [
              {
                   id: "dataFileType",
                   name: "Data File Type",
                   isShow: true,
                   align: "left",
                   type: "text",
              },
              {
                   id: "schemaName",
                   name: "Schema Name",
                   isShow: true,
                   align: "left",
                   type: "text",
              },
              {
                   id: "date",
                   name: "Date",
                   isShow: true,
                   align: "center",
                   type: "text",
                   isNormalTest: true,
              },
              {
               id: "actionMode",
               name: "Action Mode",
               isShow: true,
               align: "left",
               type: "text",
               },
              {
                   id: "status",
                   name: "Status",
                   isShow: true,
                   align: "left",
                   type: "text",
              },
              {
                   id: "",
                   name: "",
                   isShow: true,
                   align: "left",
                   type: "",
              },
              {
                   id: "",
                   name: "",
                   isShow: true,
                   align: "left",
                   type: "",
              },
              {
               id: "",
               name: "",
               isShow: true,
               align: "left",
               type: "",
          },
              
              
         ],
    },
    dataUploadURL:'https://as-sherbet-api-storage-dev.azurewebsites.net/api/FileUpload',
    downloadLink:'https://as-sherbet-api-incentive-dev.azurewebsites.net/',
};
